import { render, staticRenderFns } from "./settlement-detailed-list.vue?vue&type=template&id=8248efe8&scoped=true"
import script from "./settlement-detailed-list.vue?vue&type=script&lang=js"
export * from "./settlement-detailed-list.vue?vue&type=script&lang=js"
import style0 from "./settlement-detailed-list.vue?vue&type=style&index=0&id=8248efe8&prod&scoped=true&lang=css"
import style1 from "./settlement-detailed-list.vue?vue&type=style&index=1&id=8248efe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8248efe8",
  null
  
)

export default component.exports